import React, { useState } from "react";
import PropTypes from "prop-types";
import { GiForkKnifeSpoon, GiGlassCognac, GiBreadSlice } from "react-icons/gi"; // Importamos los íconos
import { IconList } from "./IconList"; // Asegúrate de tener este componente importado
import './menuwithsections.css';

// Función para capitalizar la primera letra de un texto
const capitalizeFirstLetter = (text) => {
  if (typeof text !== "string") return text;
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

const MenuWithSections = ({ comidas, bebidas, complementos, paquete }) => {
  // Estado para gestionar las secciones abiertas
  const [openSections, setOpenSections] = useState([false, false, false]);

  // Función para alternar la visibilidad de las secciones del menú
  const handleToggleSection = (sectionIndex) => {
    setOpenSections((prevOpenSections) =>
      prevOpenSections.includes(sectionIndex)
        ? prevOpenSections.filter((index) => index !== sectionIndex) // Cerrar la sección si ya está abierta
        : [...prevOpenSections, sectionIndex] // Abrir la sección si no está abierta
    );
  };

  // ✅ Extraer bebidas y complementos de todas las comidas
  bebidas = comidas?.flatMap(comida => comida.bebidas || []) || [];
  complementos = comidas?.flatMap(comida => comida.complementos || []) || [];


  console.log("Datos recibidos: ", { comidas, bebidas, complementos });

  return (
    <div className="menu">
      {/* <h2 className="menu-title along-menu">Menú</h2> */}
      {/* Sección principal 3 Tiempos */}
      {comidas && comidas.length > 0 && (
  <div className="type-list along-section">
    {/* ✅ Solo se muestra si flag no es 0 */}
    {paquete === "con paquete" ? (
      <h2 onClick={() => handleToggleSection(0)} className="section-title">
        <div className="with-sections">
          {comidas[0].tipoMenu}
        </div>
        <GiForkKnifeSpoon
          className={`icon-menu ${
            openSections.includes(0) ? "icon-expanded" : "icon-collapsed"
          }`}
        />
      </h2>
    ) : (
      <h2 onClick={() => handleToggleSection(0)} className="section-title">
        <div className="with-sections">
          {comidas[0].tipoMenu}
        </div>
        <GiForkKnifeSpoon
          className={`icon-menu ${
            openSections.includes(0) ? "icon-expanded" : "icon-collapsed"
          }`}
        />
      </h2>
    )}

    {/* Si la sección "3 Tiempos" está abierta, mostrar subsecciones */}
    {openSections.includes(0) && (
      <div className="section-content-along">
        {/* Sección de Comidas */}
        <div className="sub-section-along">
          {comidas.map((comida, idx) => (
            <div key={idx}>
              {comida.tiempos.map((tiempo, tiIdx) => (
                <div key={tiIdx}>
                  <h3>{tiempo.tiempoMenu}</h3>
                  <IconList
                    items={tiempo.platillos.map(capitalizeFirstLetter)}
                    itemType="platillo"
                    className="item-list along-list"
                  />
                </div>
              ))}
            </div>
          ))}
        </div>

        {/* Sección de Bebidas */}
        {bebidas && bebidas.length > 0 && (
          <div className="sub-section-along">
            <h3 className="capitalize-first-letter">Bebidas</h3>
            <IconList
              items={bebidas.map((bebida) => capitalizeFirstLetter(bebida))}
              itemType="bebida"
              className="item-list along-list"
            />
          </div>
        )}

        {/* Sección de Complementos */}
        {complementos && complementos.length > 0 && (
          <div className="sub-section-along">
            <h3 className="capitalize-first-letter">Complementos</h3>
            <IconList
              items={complementos.map((complemento) => capitalizeFirstLetter(complemento))}
              itemType="complemento"
              className="item-list along-list"
            />
          </div>
        )}
      </div>
    )}
  </div>
)}

    </div>
  );
};

MenuWithSections.propTypes = {
  comidas: PropTypes.arrayOf(
    PropTypes.shape({
      tiempos: PropTypes.arrayOf(PropTypes.object).isRequired, // Lista de tiempos de comida
    })
  ).isRequired,
  bebidas: PropTypes.arrayOf(
    PropTypes.shape({
      nombre: PropTypes.string.isRequired, // Nombre de la bebida
    })
  ).isRequired,
  complementos: PropTypes.arrayOf(
    PropTypes.shape({
      nombre: PropTypes.string.isRequired, // Nombre del complemento
    })
  ).isRequired,
};

export default MenuWithSections;
